const countryList = [
    {
       "label":"Afghanistan",
       "dial_code":"+93",
       "name":"AF"
    },
    {
       "label":"Aland Islands",
       "dial_code":"+358",
       "name":"AX"
    },
    {
       "label":"Albania",
       "dial_code":"+355",
       "name":"AL"
    },
    {
       "label":"Algeria",
       "dial_code":"+213",
       "name":"DZ"
    },
    {
       "label":"AmericanSamoa",
       "dial_code":"+1684",
       "name":"AS"
    },
    {
       "label":"Andorra",
       "dial_code":"+376",
       "name":"AD"
    },
    {
       "label":"Angola",
       "dial_code":"+244",
       "name":"AO"
    },
    {
       "label":"Anguilla",
       "dial_code":"+1264",
       "name":"AI"
    },
    {
       "label":"Antarctica",
       "dial_code":"+672",
       "name":"AQ"
    },
    {
       "label":"Antigua and Barbuda",
       "dial_code":"+1268",
       "name":"AG"
    },
    {
       "label":"Argentina",
       "dial_code":"+54",
       "name":"AR"
    },
    {
       "label":"Armenia",
       "dial_code":"+374",
       "name":"AM"
    },
    {
       "label":"Aruba",
       "dial_code":"+297",
       "name":"AW"
    },
    {
       "label":"Australia",
       "dial_code":"+61",
       "name":"AU"
    },
    {
       "label":"Austria",
       "dial_code":"+43",
       "name":"AT"
    },
    {
       "label":"Azerbaijan",
       "dial_code":"+994",
       "name":"AZ"
    },
    {
       "label":"Bahamas",
       "dial_code":"+1242",
       "name":"BS"
    },
    {
       "label":"Bahrain",
       "dial_code":"+973",
       "name":"BH"
    },
    {
       "label":"Bangladesh",
       "dial_code":"+880",
       "name":"BD"
    },
    {
       "label":"Barbados",
       "dial_code":"+1246",
       "name":"BB"
    },
    {
       "label":"Belarus",
       "dial_code":"+375",
       "name":"BY"
    },
    {
       "label":"Belgium",
       "dial_code":"+32",
       "name":"BE"
    },
    {
       "label":"Belize",
       "dial_code":"+501",
       "name":"BZ"
    },
    {
       "label":"Benin",
       "dial_code":"+229",
       "name":"BJ"
    },
    {
       "label":"Bermuda",
       "dial_code":"+1441",
       "name":"BM"
    },
    {
       "label":"Bhutan",
       "dial_code":"+975",
       "name":"BT"
    },
    {
       "label":"Bolivia, Plurinational State of",
       "dial_code":"+591",
       "name":"BO"
    },
    {
       "label":"Bosnia and Herzegovina",
       "dial_code":"+387",
       "name":"BA"
    },
    {
       "label":"Botswana",
       "dial_code":"+267",
       "name":"BW"
    },
    {
       "label":"Brazil",
       "dial_code":"+55",
       "name":"BR"
    },
    {
       "label":"British Indian Ocean Territory",
       "dial_code":"+246",
       "name":"IO"
    },
    {
       "label":"Brunei Darussalam",
       "dial_code":"+673",
       "name":"BN"
    },
    {
       "label":"Bulgaria",
       "dial_code":"+359",
       "name":"BG"
    },
    {
       "label":"Burkina Faso",
       "dial_code":"+226",
       "name":"BF"
    },
    {
       "label":"Burundi",
       "dial_code":"+257",
       "name":"BI"
    },
    {
       "label":"Cambodia",
       "dial_code":"+855",
       "name":"KH"
    },
    {
       "label":"Cameroon",
       "dial_code":"+237",
       "name":"CM"
    },
    {
       "label":"Canada",
       "dial_code":"+1",
       "name":"CA"
    },
    {
       "label":"Cape Verde",
       "dial_code":"+238",
       "name":"CV"
    },
    {
       "label":"Cayman Islands",
       "dial_code":"+ 345",
       "name":"KY"
    },
    {
       "label":"Central African Republic",
       "dial_code":"+236",
       "name":"CF"
    },
    {
       "label":"Chad",
       "dial_code":"+235",
       "name":"TD"
    },
    {
       "label":"Chile",
       "dial_code":"+56",
       "name":"CL"
    },
    {
       "label":"China",
       "dial_code":"+86",
       "name":"CN"
    },
    {
       "label":"Christmas Island",
       "dial_code":"+61",
       "name":"CX"
    },
    {
       "label":"Cocos (Keeling) Islands",
       "dial_code":"+61",
       "name":"CC"
    },
    {
       "label":"Colombia",
       "dial_code":"+57",
       "name":"CO"
    },
    {
       "label":"Comoros",
       "dial_code":"+269",
       "name":"KM"
    },
    {
       "label":"Congo",
       "dial_code":"+242",
       "name":"CG"
    },
    {
       "label":"Congo, The Democratic Republic of the Congo",
       "dial_code":"+243",
       "name":"CD"
    },
    {
       "label":"Cook Islands",
       "dial_code":"+682",
       "name":"CK"
    },
    {
       "label":"Costa Rica",
       "dial_code":"+506",
       "name":"CR"
    },
    {
       "label":"Cote d'Ivoire",
       "dial_code":"+225",
       "name":"CI"
    },
    {
       "label":"Croatia",
       "dial_code":"+385",
       "name":"HR"
    },
    {
       "label":"Cuba",
       "dial_code":"+53",
       "name":"CU"
    },
    {
       "label":"Cyprus",
       "dial_code":"+357",
       "name":"CY"
    },
    {
       "label":"Czech Republic",
       "dial_code":"+420",
       "name":"CZ"
    },
    {
       "label":"Denmark",
       "dial_code":"+45",
       "name":"DK"
    },
    {
       "label":"Djibouti",
       "dial_code":"+253",
       "name":"DJ"
    },
    {
       "label":"Dominica",
       "dial_code":"+1767",
       "name":"DM"
    },
    {
       "label":"Dominican Republic",
       "dial_code":"+1849",
       "name":"DO"
    },
    {
       "label":"Ecuador",
       "dial_code":"+593",
       "name":"EC"
    },
    {
       "label":"Egypt",
       "dial_code":"+20",
       "name":"EG"
    },
    {
       "label":"El Salvador",
       "dial_code":"+503",
       "name":"SV"
    },
    {
       "label":"Equatorial Guinea",
       "dial_code":"+240",
       "name":"GQ"
    },
    {
       "label":"Eritrea",
       "dial_code":"+291",
       "name":"ER"
    },
    {
       "label":"Estonia",
       "dial_code":"+372",
       "name":"EE"
    },
    {
       "label":"Ethiopia",
       "dial_code":"+251",
       "name":"ET"
    },
    {
       "label":"Falkland Islands (Malvinas)",
       "dial_code":"+500",
       "name":"FK"
    },
    {
       "label":"Faroe Islands",
       "dial_code":"+298",
       "name":"FO"
    },
    {
       "label":"Fiji",
       "dial_code":"+679",
       "name":"FJ"
    },
    {
       "label":"Finland",
       "dial_code":"+358",
       "name":"FI"
    },
    {
       "label":"France",
       "dial_code":"+33",
       "name":"FR"
    },
    {
       "label":"French Guiana",
       "dial_code":"+594",
       "name":"GF"
    },
    {
       "label":"French Polynesia",
       "dial_code":"+689",
       "name":"PF"
    },
    {
       "label":"Gabon",
       "dial_code":"+241",
       "name":"GA"
    },
    {
       "label":"Gambia",
       "dial_code":"+220",
       "name":"GM"
    },
    {
       "label":"Georgia",
       "dial_code":"+995",
       "name":"GE"
    },
    {
       "label":"Germany",
       "dial_code":"+49",
       "name":"DE"
    },
    {
       "label":"Ghana",
       "dial_code":"+233",
       "name":"GH"
    },
    {
       "label":"Gibraltar",
       "dial_code":"+350",
       "name":"GI"
    },
    {
       "label":"Greece",
       "dial_code":"+30",
       "name":"GR"
    },
    {
       "label":"Greenland",
       "dial_code":"+299",
       "name":"GL"
    },
    {
       "label":"Grenada",
       "dial_code":"+1473",
       "name":"GD"
    },
    {
       "label":"Guadeloupe",
       "dial_code":"+590",
       "name":"GP"
    },
    {
       "label":"Guam",
       "dial_code":"+1671",
       "name":"GU"
    },
    {
       "label":"Guatemala",
       "dial_code":"+502",
       "name":"GT"
    },
    {
       "label":"Guernsey",
       "dial_code":"+44",
       "name":"GG"
    },
    {
       "label":"Guinea",
       "dial_code":"+224",
       "name":"GN"
    },
    {
       "label":"Guinea-Bissau",
       "dial_code":"+245",
       "name":"GW"
    },
    {
       "label":"Guyana",
       "dial_code":"+595",
       "name":"GY"
    },
    {
       "label":"Haiti",
       "dial_code":"+509",
       "name":"HT"
    },
    {
       "label":"Holy See (Vatican City State)",
       "dial_code":"+379",
       "name":"VA"
    },
    {
       "label":"Honduras",
       "dial_code":"+504",
       "name":"HN"
    },
    {
       "label":"Hong Kong",
       "dial_code":"+852",
       "name":"HK"
    },
    {
       "label":"Hungary",
       "dial_code":"+36",
       "name":"HU"
    },
    {
       "label":"Iceland",
       "dial_code":"+354",
       "name":"IS"
    },
    {
       "label":"India",
       "dial_code":"+91",
       "name":"IN"
    },
    {
       "label":"Indonesia",
       "dial_code":"+62",
       "name":"ID"
    },
    {
       "label":"Iran, Islamic Republic of Persian Gulf",
       "dial_code":"+98",
       "name":"IR"
    },
    {
       "label":"Iraq",
       "dial_code":"+964",
       "name":"IQ"
    },
    {
       "label":"Ireland",
       "dial_code":"+353",
       "name":"IE"
    },
    {
       "label":"Isle of Man",
       "dial_code":"+44",
       "name":"IM"
    },
    {
       "label":"Israel",
       "dial_code":"+972",
       "name":"IL"
    },
    {
       "label":"Italy",
       "dial_code":"+39",
       "name":"IT"
    },
    {
       "label":"Jamaica",
       "dial_code":"+1876",
       "name":"JM"
    },
    {
       "label":"Japan",
       "dial_code":"+81",
       "name":"JP"
    },
    {
       "label":"Jersey",
       "dial_code":"+44",
       "name":"JE"
    },
    {
       "label":"Jordan",
       "dial_code":"+962",
       "name":"JO"
    },
    {
       "label":"Kazakhstan",
       "dial_code":"+77",
       "name":"KZ"
    },
    {
       "label":"Kenya",
       "dial_code":"+254",
       "name":"KE"
    },
    {
       "label":"Kiribati",
       "dial_code":"+686",
       "name":"KI"
    },
    {
       "label":"Korea, Democratic People's Republic of Korea",
       "dial_code":"+850",
       "name":"KP"
    },
    {
       "label":"Korea, Republic of South Korea",
       "dial_code":"+82",
       "name":"KR"
    },
    {
       "label":"Kuwait",
       "dial_code":"+965",
       "name":"KW"
    },
    {
       "label":"Kyrgyzstan",
       "dial_code":"+996",
       "name":"KG"
    },
    {
       "label":"Laos",
       "dial_code":"+856",
       "name":"LA"
    },
    {
       "label":"Latvia",
       "dial_code":"+371",
       "name":"LV"
    },
    {
       "label":"Lebanon",
       "dial_code":"+961",
       "name":"LB"
    },
    {
       "label":"Lesotho",
       "dial_code":"+266",
       "name":"LS"
    },
    {
       "label":"Liberia",
       "dial_code":"+231",
       "name":"LR"
    },
    {
       "label":"Libyan Arab Jamahiriya",
       "dial_code":"+218",
       "name":"LY"
    },
    {
       "label":"Liechtenstein",
       "dial_code":"+423",
       "name":"LI"
    },
    {
       "label":"Lithuania",
       "dial_code":"+370",
       "name":"LT"
    },
    {
       "label":"Luxembourg",
       "dial_code":"+352",
       "name":"LU"
    },
    {
       "label":"Macao",
       "dial_code":"+853",
       "name":"MO"
    },
    {
       "label":"Macedonia",
       "dial_code":"+389",
       "name":"MK"
    },
    {
       "label":"Madagascar",
       "dial_code":"+261",
       "name":"MG"
    },
    {
       "label":"Malawi",
       "dial_code":"+265",
       "name":"MW"
    },
    {
       "label":"Malaysia",
       "dial_code":"+60",
       "name":"MY"
    },
    {
       "label":"Maldives",
       "dial_code":"+960",
       "name":"MV"
    },
    {
       "label":"Mali",
       "dial_code":"+223",
       "name":"ML"
    },
    {
       "label":"Malta",
       "dial_code":"+356",
       "name":"MT"
    },
    {
       "label":"Marshall Islands",
       "dial_code":"+692",
       "name":"MH"
    },
    {
       "label":"Martinique",
       "dial_code":"+596",
       "name":"MQ"
    },
    {
       "label":"Mauritania",
       "dial_code":"+222",
       "name":"MR"
    },
    {
       "label":"Mauritius",
       "dial_code":"+230",
       "name":"MU"
    },
    {
       "label":"Mayotte",
       "dial_code":"+262",
       "name":"YT"
    },
    {
       "label":"Mexico",
       "dial_code":"+52",
       "name":"MX"
    },
    {
       "label":"Micronesia, Federated States of Micronesia",
       "dial_code":"+691",
       "name":"FM"
    },
    {
       "label":"Moldova",
       "dial_code":"+373",
       "name":"MD"
    },
    {
       "label":"Monaco",
       "dial_code":"+377",
       "name":"MC"
    },
    {
       "label":"Mongolia",
       "dial_code":"+976",
       "name":"MN"
    },
    {
       "label":"Montenegro",
       "dial_code":"+382",
       "name":"ME"
    },
    {
       "label":"Montserrat",
       "dial_code":"+1664",
       "name":"MS"
    },
    {
       "label":"Morocco",
       "dial_code":"+212",
       "name":"MA"
    },
    {
       "label":"Mozambique",
       "dial_code":"+258",
       "name":"MZ"
    },
    {
       "label":"Myanmar",
       "dial_code":"+95",
       "name":"MM"
    },
    {
       "label":"Namibia",
       "dial_code":"+264",
       "name":"NA"
    },
    {
       "label":"Nauru",
       "dial_code":"+674",
       "name":"NR"
    },
    {
       "label":"Nepal",
       "dial_code":"+977",
       "name":"NP"
    },
    {
       "label":"Netherlands",
       "dial_code":"+31",
       "name":"NL"
    },
    {
       "label":"Netherlands Antilles",
       "dial_code":"+599",
       "name":"AN"
    },
    {
       "label":"New Caledonia",
       "dial_code":"+687",
       "name":"NC"
    },
    {
       "label":"New Zealand",
       "dial_code":"+64",
       "name":"NZ"
    },
    {
       "label":"Nicaragua",
       "dial_code":"+505",
       "name":"NI"
    },
    {
       "label":"Niger",
       "dial_code":"+227",
       "name":"NE"
    },
    {
       "label":"Nigeria",
       "dial_code":"+234",
       "name":"NG"
    },
    {
       "label":"Niue",
       "dial_code":"+683",
       "name":"NU"
    },
    {
       "label":"Norfolk Island",
       "dial_code":"+672",
       "name":"NF"
    },
    {
       "label":"Northern Mariana Islands",
       "dial_code":"+1670",
       "name":"MP"
    },
    {
       "label":"Norway",
       "dial_code":"+47",
       "name":"NO"
    },
    {
       "label":"Oman",
       "dial_code":"+968",
       "name":"OM"
    },
    {
       "label":"Pakistan",
       "dial_code":"+92",
       "name":"PK"
    },
    {
       "label":"Palau",
       "dial_code":"+680",
       "name":"PW"
    },
    {
       "label":"Palestinian Territory, Occupied",
       "dial_code":"+970",
       "name":"PS"
    },
    {
       "label":"Panama",
       "dial_code":"+507",
       "name":"PA"
    },
    {
       "label":"Papua New Guinea",
       "dial_code":"+675",
       "name":"PG"
    },
    {
       "label":"Paraguay",
       "dial_code":"+595",
       "name":"PY"
    },
    {
       "label":"Peru",
       "dial_code":"+51",
       "name":"PE"
    },
    {
       "label":"Philippines",
       "dial_code":"+63",
       "name":"PH"
    },
    {
       "label":"Pitcairn",
       "dial_code":"+872",
       "name":"PN"
    },
    {
       "label":"Poland",
       "dial_code":"+48",
       "name":"PL"
    },
    {
       "label":"Portugal",
       "dial_code":"+351",
       "name":"PT"
    },
    {
       "label":"Puerto Rico",
       "dial_code":"+1939",
       "name":"PR"
    },
    {
       "label":"Qatar",
       "dial_code":"+974",
       "name":"QA"
    },
    {
       "label":"Romania",
       "dial_code":"+40",
       "name":"RO"
    },
    {
       "label":"Russia",
       "dial_code":"+7",
       "name":"RU"
    },
    {
       "label":"Rwanda",
       "dial_code":"+250",
       "name":"RW"
    },
    {
       "label":"Reunion",
       "dial_code":"+262",
       "name":"RE"
    },
    {
       "label":"Saint Barthelemy",
       "dial_code":"+590",
       "name":"BL"
    },
    {
       "label":"Saint Helena, Ascension and Tristan Da Cunha",
       "dial_code":"+290",
       "name":"SH"
    },
    {
       "label":"Saint Kitts and Nevis",
       "dial_code":"+1869",
       "name":"KN"
    },
    {
       "label":"Saint Lucia",
       "dial_code":"+1758",
       "name":"LC"
    },
    {
       "label":"Saint Martin",
       "dial_code":"+590",
       "name":"MF"
    },
    {
       "label":"Saint Pierre and Miquelon",
       "dial_code":"+508",
       "name":"PM"
    },
    {
       "label":"Saint Vincent and the Grenadines",
       "dial_code":"+1784",
       "name":"VC"
    },
    {
       "label":"Samoa",
       "dial_code":"+685",
       "name":"WS"
    },
    {
       "label":"San Marino",
       "dial_code":"+378",
       "name":"SM"
    },
    {
       "label":"Sao Tome and Principe",
       "dial_code":"+239",
       "name":"ST"
    },
    {
       "label":"Saudi Arabia",
       "dial_code":"+966",
       "name":"SA"
    },
    {
       "label":"Senegal",
       "dial_code":"+221",
       "name":"SN"
    },
    {
       "label":"Serbia",
       "dial_code":"+381",
       "name":"RS"
    },
    {
       "label":"Seychelles",
       "dial_code":"+248",
       "name":"SC"
    },
    {
       "label":"Sierra Leone",
       "dial_code":"+232",
       "name":"SL"
    },
    {
       "label":"Singapore",
       "dial_code":"+65",
       "name":"SG"
    },
    {
       "label":"Slovakia",
       "dial_code":"+421",
       "name":"SK"
    },
    {
       "label":"Slovenia",
       "dial_code":"+386",
       "name":"SI"
    },
    {
       "label":"Solomon Islands",
       "dial_code":"+677",
       "name":"SB"
    },
    {
       "label":"Somalia",
       "dial_code":"+252",
       "name":"SO"
    },
    {
       "label":"South Africa",
       "dial_code":"+27",
       "name":"ZA"
    },
    {
       "label":"South Sudan",
       "dial_code":"+211",
       "name":"SS"
    },
    {
       "label":"South Georgia and the South Sandwich Islands",
       "dial_code":"+500",
       "name":"GS"
    },
    {
       "label":"Spain",
       "dial_code":"+34",
       "name":"ES"
    },
    {
       "label":"Sri Lanka",
       "dial_code":"+94",
       "name":"LK"
    },
    {
       "label":"Sudan",
       "dial_code":"+249",
       "name":"SD"
    },
    {
       "label":"Suriname",
       "dial_code":"+597",
       "name":"SR"
    },
    {
       "label":"Svalbard and Jan Mayen",
       "dial_code":"+47",
       "name":"SJ"
    },
    {
       "label":"Swaziland",
       "dial_code":"+268",
       "name":"SZ"
    },
    {
       "label":"Sweden",
       "dial_code":"+46",
       "name":"SE"
    },
    {
       "label":"Switzerland",
       "dial_code":"+41",
       "name":"CH"
    },
    {
       "label":"Syrian Arab Republic",
       "dial_code":"+963",
       "name":"SY"
    },
    {
       "label":"Taiwan",
       "dial_code":"+886",
       "name":"TW"
    },
    {
       "label":"Tajikistan",
       "dial_code":"+992",
       "name":"TJ"
    },
    {
       "label":"Tanzania, United Republic of Tanzania",
       "dial_code":"+255",
       "name":"TZ"
    },
    {
       "label":"Thailand",
       "dial_code":"+66",
       "name":"TH"
    },
    {
       "label":"Timor-Leste",
       "dial_code":"+670",
       "name":"TL"
    },
    {
       "label":"Togo",
       "dial_code":"+228",
       "name":"TG"
    },
    {
       "label":"Tokelau",
       "dial_code":"+690",
       "name":"TK"
    },
    {
       "label":"Tonga",
       "dial_code":"+676",
       "name":"TO"
    },
    {
       "label":"Trinidad and Tobago",
       "dial_code":"+1868",
       "name":"TT"
    },
    {
       "label":"Tunisia",
       "dial_code":"+216",
       "name":"TN"
    },
    {
       "label":"Turkey",
       "dial_code":"+90",
       "name":"TR"
    },
    {
       "label":"Turkmenistan",
       "dial_code":"+993",
       "name":"TM"
    },
    {
       "label":"Turks and Caicos Islands",
       "dial_code":"+1649",
       "name":"TC"
    },
    {
       "label":"Tuvalu",
       "dial_code":"+688",
       "name":"TV"
    },
    {
       "label":"Uganda",
       "dial_code":"+256",
       "name":"UG"
    },
    {
       "label":"Ukraine",
       "dial_code":"+380",
       "name":"UA"
    },
    {
       "label":"United Arab Emirates",
       "dial_code":"+971",
       "name":"AE"
    },
    {
       "label":"United Kingdom",
       "dial_code":"+44",
       "name":"GB"
    },
    {
       "label":"United States",
       "dial_code":"+1",
       "name":"US"
    },
    {
       "label":"Uruguay",
       "dial_code":"+598",
       "name":"UY"
    },
    {
       "label":"Uzbekistan",
       "dial_code":"+998",
       "name":"UZ"
    },
    {
       "label":"Vanuatu",
       "dial_code":"+678",
       "name":"VU"
    },
    {
       "label":"Venezuela, Bolivarian Republic of Venezuela",
       "dial_code":"+58",
       "name":"VE"
    },
    {
       "label":"Vietnam",
       "dial_code":"+84",
       "name":"VN"
    },
    {
       "label":"Virgin Islands, British",
       "dial_code":"+1284",
       "name":"VG"
    },
    {
       "label":"Virgin Islands, U.S.",
       "dial_code":"+1340",
       "name":"VI"
    },
    {
       "label":"Wallis and Futuna",
       "dial_code":"+681",
       "name":"WF"
    },
    {
       "label":"Yemen",
       "dial_code":"+967",
       "name":"YE"
    },
    {
       "label":"Zambia",
       "dial_code":"+260",
       "name":"ZM"
    },
    {
       "label":"Zimbabwe",
       "dial_code":"+263",
       "name":"ZW"
    }
 ];

const dataBaseTypes = [{ id: 1, name: "mysql", label: "MY SQL"},{ id: 2, name: "mssql", label: "MS SQL"},{ id: 3, name: "postgresql", label: "POSTGRE SQL"},{ id: 4, name: "databricks", label: "DATABRICKS"},
];
  
const masterKeyDataTypes = [{ id: 1, name: "number", label: "Number"},{ id: 2, name: "string", label: "String"},{ id: 3, name: "date", label: "Date"},
];
  
const masterKeyRecordTypesArray = [{ id: 1, name: "header", label: "Header"},{ id: 2, name: "trailer", label: "Trailer"},{ id: 3, name: "record", label: "Record"}
];

const fileFormatList = [
    { id: 1, name: "fixed", label: "Fixed Length"},
    { id: 2, name: "delimit", label: "Delimit"},
    { id: 3, name: "excel", label: "Excel File"},
    { id: 4, name: "csv", label: "CSV File"},
    { id: 5, name: "txt", label: "TXT File"},
    { id: 6, name: "access", label: "Access"},
  ];

const date = new Date();
const currentyear = date.getUTCFullYear();
let YEAR = [
    { id: 1, name: currentyear-3, label: currentyear-3 },
    { id: 2, name: currentyear-2, label: currentyear-2 },
    { id: 3, name: currentyear-1, label: currentyear-1 },
    { id: 4, name: currentyear, label: currentyear },
    { id: 5, name: currentyear+1, label: currentyear+1 },
    { id: 6, name: currentyear+2, label: currentyear+2 },
];

const MONTHS = [
    { id: 1, name: "January", label: "January" },
    { id: 2, name: "February", label: "February" },
    { id: 3, name: "March", label: "March" },
    { id: 4, name: "April", label: "April" },
    { id: 5, name: "May", label: "May" },
    { id: 6, name: "June", label: "June" },
    { id: 7, name: "July", label: "July" },
    { id: 8, name: "August", label: "August" },
    { id: 9, name: "September", label: "September" },
    { id: 10, name: "October", label: "October" },
    { id: 11, name: "November", label: "November" },
    { id: 12, name: "December", label: "December" },
  ];

const batchOptions = [
    { id: 1, name: "process", label: "Process"},
    { id: 2, name: "cancel", label: "Cancel"},
    { id: 3, name: "delete", label: "Delete"},
    { id: 4, name: "upload", label: "Upload"},
    { id: 5, name: "reprocess", label: "Re-Process"},
    { id: 6, name: "reupload", label: "Re-Upload"},
  ];

const columnIndexList = [
   { id: 1, name: "col1", label: "Col 1"},
   { id: 2, name: "col2", label: "Col 2"},
   { id: 3, name: "col3", label: "Col 3"},
   { id: 4, name: "col3", label: "Col 4"},
   { id: 5, name: "col5", label: "Col 5"},
   { id: 6, name: "last", label: "Col Last"},
 ];

 const columnConditionList = [
   { id: 1, name: "in", label: "IN"},
   { id: 2, name: "notin", label: "NOT IN"},
   { id: 3, name: "startwith", label: "START WITH"},
   { id: 4, name: "endwith", label: "END WITH"},
 ];

 const inputFileTypeList = [
   { id: 1, name: "BILLWISE", label: "BILLWISE"},
   { id: 2, name: "PRODUCTWISE", label: "PRODUCTWISE"}
 ];


module.exports = { 
    countryList, 
    dataBaseTypes, 
    masterKeyDataTypes, 
    masterKeyRecordTypesArray, 
    fileFormatList, 
    yearList: YEAR,
    monthList: MONTHS,
    batchOptions,
    columnIndexList,
    columnConditionList,
    inputFileTypeList
 };